import "@/App.css";
import SpatialNarrativeApp from "@/components/SpatialNarrativeApp";

function App() {
  return <SpatialNarrativeApp />;
}

export default App;
